var map = {
	"./ODR.svg": "60d3",
	"./circle-flyer.svg": "e374",
	"./circle-letter.svg": "f1ea",
	"./circle-postcard.svg": "ac72",
	"./common/empty-mailbox.svg": "a2b6",
	"./common/empty_mailbox_color.svg": "b55a",
	"./common/estimate_letter.svg": "4c13",
	"./common/estimate_letter_grey.svg": "2ba0",
	"./double-sided.svg": "8c05",
	"./envelope-confetti.svg": "a52b",
	"./file-upload-address.svg": "71c2",
	"./file-upload-pdf-doc-ghosted.svg": "1352",
	"./file-upload-pdf-doc.svg": "576b",
	"./file-upload-success.svg": "b402",
	"./file-upload.svg": "8930",
	"./learn-more.svg": "588a",
	"./letter_template.png": "4893",
	"./letters/address/add-manually.svg": "6ce6",
	"./letters/address/upload-cloud.svg": "6fcc",
	"./letters/number-input/minus-circle-disabled.svg": "2888",
	"./letters/number-input/minus-circle.svg": "b8c9",
	"./letters/number-input/plus-circle-disabled.svg": "36ce",
	"./letters/number-input/plus-circle.svg": "a2ec",
	"./letters/orders/my-mailouts-end.svg": "4c45",
	"./letters/pay/credit-card.svg": "9f83",
	"./letters/pay/direct-transfer.svg": "c408",
	"./letters/pay/invoice-disabled.svg": "87bd",
	"./letters/pay/invoice.svg": "a962",
	"./letters/pay/mailouts-mailbox-error.svg": "20ef",
	"./letters/pay/mailouts-mailbox-processing.svg": "c1c5",
	"./letters/pay/mailouts-mailbox-success.svg": "51dd",
	"./mailbox-letter-flower.svg": "224f",
	"./order-activity-mailbox.svg": "f2be",
	"./product-edi-invoice.svg": "9545",
	"./product-flyer-with-envelope-2.svg": "be61",
	"./product-flyer.svg": "f0f5",
	"./product-letter-envelope.svg": "b76e",
	"./product-postcard-business.svg": "887f",
	"./send-out-arrival.svg": "8e5e",
	"./single-sided.svg": "a9b2",
	"./try-test-file.svg": "75eb",
	"./upload-cloud.svg": "b0a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";